export default {
    infoList:[
        {
            value:'中医大数据',
            type:1,
            children:[
                {
                    value:'文献大数据平台',
                    url:'https://ai.tcmcds.com/wenxian/login',
                },
                {
                    value:'中医词网',
                    url:'https://ai.tcmcds.com/wenxian/login',
                }, 
                {
                    value:'知识图谱',
                    url:'https://ai.tcmcds.com/zhGraph/index.html',
                },
            ]
        },
        {
            value:'知识服务',
            type:2,
            children:[
                {
                    // value:'诊疗体系重构',
                    value:'中医学专业知识服务系统',
                    url:'https://ai.tcmcds.com/tcmkb/'
                },
                {
                    value:'治未病专业知识服务系统',
                    url:''
                },
                {
                    value:'脾胃病专业知识服务系统',
                    url:'https://ai.tcmcds.com/pw2/login'
                },
                {
                    value:'《黄帝内经》理论研究<br>知识服务系统',
                    url:'https://ai.tcmcds.com/hdnj/login'
                }
            ]
        },
        {
            value:'智能算法',
            type:3,
            children:[
                {
                    value:'舌诊', 
                    url:'',
                },
                {
                    value:'面诊',
                    url:'',
                },
                {
                    value:'养生推荐',
                    url:'https://ai.tcmcds.com/wenzhen',
                },  
                
            ]
        },
        {
            value:'智能硬件',
            type:4,
            children:[
                {
                    value:'中医养生仪', 
                    url:'',
                    path:'/introTizhi'
                },
                {
                    value:'中医助理智能机器人',
                    url:'',
                    path:'/introAssistant'
                    
                },
                {
                    value:'中医传承工作站',
                    url:'',
                    path:'/introChuancheng'
                },  
                
            ]
        },
        
    ],
    headerNav:[
        {
            value:'中医大数据',
            type:1,
            children:[
                {
                    value:'文献大数据平台',
                    url:'https://ai.tcmcds.com/wenxian/login',
                },
                {
                    value:'中医词网',
                    url:'https://ai.tcmcds.com/wenxian/login',
                }, 
                {
                    value:'知识图谱',
                    url:'https://ai.tcmcds.com/zhGraph/index.html',
                }, 
            ]
        },
        {
            value:'知识服务',
            type:2,
            children:[
                {
                    // value:'诊疗体系重构',
                    value:'中医学专业知识服务系统',
                    url:'https://ai.tcmcds.com/tcmkb/'
                },
                {
                    value:'治未病专业知识服务系统',
                    url:''
                },
                {
                    value:'脾胃病专业知识服务系统',
                    url:'https://ai.tcmcds.com/pw2/login'
                },
                {
                    value:'《黄帝内经》理论研究知识服务系统',
                    url:'https://ai.tcmcds.com/hdnj/login'
                }
            ]
        },
        {
            value:'智能算法',
            type:3,
            children:[
                {
                    value:'舌诊', 
                    url:'',
                },
                {
                    value:'面诊',
                    url:'',
                },
                {
                    value:'养生推荐',
                    url:'https://ai.tcmcds.com/wenzhen',
                },  
                
            ]
        },
        {
            value:'智能硬件',
            type:4,
            children:[
                {
                    value:'中医养生仪', 
                    url:'',
                    path:'/introTizhi'
                },
                {
                    value:'中医助理智能机器人',
                    url:'',
                    path:'/introAssistant'
                    
                },
                {
                    value:'中医传承工作站',
                    url:'',
                    path:'/introChuancheng'
                },  
                
            ]
        },
    ],
    loadingType:[
        {
            value:'账号登录',
            type:1
        },
        {
            value:'短信登录',
            type:2
        },
    ],
}